export function getDate(date) {
  return new Date(date ? 1000 * parseInt(date) : 0);
}